import { Text } from '@chakra-ui/react'

// import { clamp } from '@/lib/helpers'

const NUMBER_HEIGHT = 420

interface Props {
  id?: string
  primaryColor: string
  index: number
  containerRef?: React.RefObject<HTMLDivElement>
}

function ParallaxNumber({
  id,
  primaryColor,
  index,
}: Props): React.ReactElement {
  const isOdd = index % 2 === 0

  const posY = 0
  // const [posY, setPosY] = useState(0)

  // useEffect(() => {
  //   if (!containerRef?.current) return

  //   const handleScroll = () => {
  //     if (!containerRef?.current) return

  //     const windowHeight = window.innerHeight
  //     const containerBoundingRect = containerRef.current.getBoundingClientRect()

  //     const percentMoving = 1 - containerBoundingRect.y / windowHeight

  //     const value = clamp(
  //       percentMoving * containerBoundingRect.height - NUMBER_HEIGHT,
  //       0,
  //       containerBoundingRect.height - NUMBER_HEIGHT,
  //     )

  //     setPosY(value)
  //   }

  //   document.addEventListener('scroll', handleScroll)

  //   handleScroll()

  //   return () => {
  //     document.removeEventListener('scroll', handleScroll)
  //   }
  // }, [containerRef?.current])

  return (
    <Text
      id={id}
      style={{
        transform: `translate3d(${
          isOdd ? '50%' : '-50%'
        }, calc(${posY}px - 5%), 0)`,
      }}
      sx={{
        display: {
          base: 'none',
          'lg+': 'block',
        },
        position: 'absolute',
        w: 'fit-content',
        fontSize: '320px',
        color: 'transparent',
        WebkitTextStroke: `1px ${primaryColor}`,
        left: isOdd ? 'unset' : '11%',
        right: isOdd ? '11%' : 'unset',
        transition: 'transform 2000ms ease-in-out',
        height: `${NUMBER_HEIGHT}px`,
      }}
    >
      {index + 1}
    </Text>
  )
}

export default ParallaxNumber
